import { render } from "./baseerrorsuccessmessage.vue?vue&type=template&id=1fe9e556"
import script from "./baseerrorsuccessmessage.vue?vue&type=script&lang=js"
export * from "./baseerrorsuccessmessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__